<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item :link="{ name: 'Dashboard', icon: 'ni ni-shop text-primary', path: '/dashboard' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Prior Authorizations', icon: 'fas fa-file-contract text-info', path: '/pa' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Patient Lookup', icon: 'fa fa-user text-success', path: '/patient' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Pricing', icon: 'fa fa-dollar-sign text-primary', path: '/pricing' }">
          <sidebar-item :link="{ name: 'Biologics', path: '/pricing/biologics' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Carepoint Guarantee Pricing', path: '/pricing/CPGuaranteeInsured' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Generic Cash Pricing', path: '/pricing/GenericCash' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Dermatology', path: '/pricing/Dermatology' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Podiatry', path: '/pricing/Podietry' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Neurology & Psych', path: '/pricing/NumAndPsych' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Respiratory', path: '/pricing/Respiratory' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Rheumatology', path: '/pricing/Rheumotology' }"></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
//import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    //DashboardContent,
    FadeTransition
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    }
  },
  mounted() {
    this.initScrollbar();
  }
};
</script>
<style lang="scss">
</style>
